import { get } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';
import toValidationFailure from '@/redux/requests/lib/toValidationFailure.js';

const getAppByIdAndVersion = ({ appId, appVersion, signal } = {}, callback) => {
  const normalizedAppId = String(appId || '').trim();
  const normalizedAppVersion = String(appVersion || '').trim();

  if (!normalizedAppId) {
    return toValidationFailure('appId is required');
  }

  if (!normalizedAppVersion) {
    return toValidationFailure('appVersion is required');
  }

  return get(`/v1/apps/${encodeURIComponent(normalizedAppId)}/${encodeURIComponent(normalizedAppVersion)}`, {
    action: 'GET_APP_DEFINITION',
    callback,
    meta: {
      appId: normalizedAppId,
      appVersion: normalizedAppVersion
    },
    loader: 'getAppByIdAndVersion',
    signal,
    onResponse: (responseShape) => {
      const nextResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to load app'
      });

      if (nextResponseShape?.data?.success !== true) {
        return nextResponseShape;
      }

      const items = Array.isArray(nextResponseShape?.data?.data) ? nextResponseShape.data.data : [];

      return {
        ...nextResponseShape,
        data: {
          success: true,
          data: {
            item: items[0] || null
          }
        }
      };
    }
  });
};

export default getAppByIdAndVersion;
